var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pa-0 mt-2 ma-0",attrs:{"id":_vm.url}})
}
var staticRenderFns = []

export { render, staticRenderFns }